(function () {
  document.querySelectorAll('.tm-pdp-hero').forEach(function (hero) {
    var thumbs = hero.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        hero.querySelectorAll('.tm-pdp-hero__img').forEach(function (img) { img.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var target = hero.querySelector('#' + thumb.dataset.target);
        if (target) target.classList.add('is-active');
      });
    });

    // Purchase-option cards (mobile) show the price of the selected size
    function updatePlanPrices(variantId, price) {
      var one = hero.querySelector('[data-pdp-onetime-price]');
      if (one && price) one.textContent = price;
      hero.querySelectorAll('[data-pdp-plan-card]').forEach(function (card) {
        var el = card.querySelector('[data-pdp-plan-price]');
        var p = card.getAttribute('data-price-' + variantId);
        if (!el || !p) return;
        var c = card.getAttribute('data-compare-' + variantId);
        el.innerHTML = (c ? '<s>' + c + '</s> ' : '') + p;
      });
    }

    // Swipe between images on touch screens (dots are the thumb buttons)
    var mainImg = hero.querySelector('.tm-pdp-hero__main-image');
    if (mainImg && thumbs.length > 1) {
      var startX = null;
      mainImg.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      mainImg.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var list = Array.prototype.slice.call(thumbs);
        var i = list.findIndex(function (t) { return t.classList.contains('is-active'); });
        var next = list[i + (dx < 0 ? 1 : -1)];
        if (next) next.click();
      }, { passive: true });
    }

    var sizes = hero.querySelectorAll('.tm-pdp-size');
    var priceEl = hero.querySelector('[data-pdp-price]');
    var variantInput = hero.querySelector('[data-pdp-variant-id]');
    var cta = hero.querySelector('[data-pdp-cta]');
    sizes.forEach(function (size) {
      if (size.classList.contains('is-disabled')) return;
      size.addEventListener('click', function () {
        sizes.forEach(function (s) { s.classList.remove('is-active'); });
        size.classList.add('is-active');
        if (priceEl && size.dataset.price) priceEl.textContent = size.dataset.price;
        updatePlanPrices(size.dataset.variantId, size.dataset.price);
        if (variantInput && size.dataset.variantId) variantInput.value = size.dataset.variantId;
        if (cta) { cta.disabled = false; cta.textContent = cta.dataset.label || cta.textContent; }
      });
    });
  });
})();
